// 监课
import { sendLogById, sendLogClick } from './index'

export default {
  // 页面初始化
  initPageLogger(data) {
    sendLogById('smallfox-teacher_28', {
      ...data
    })
  },
  // 监课看板-选择小组
  selGroupLogger(data) {
    sendLogClick('smallfox-teacher_6', {
      ...data
    })
  },
  // 监课看板-未开始学习
  notStudyLogger(data) {
    sendLogClick('smallfox-teacher_5', {
      ...data
    })
  },
  // 监课看板-页面长统计
  pageTmeLogger(data) {
    sendLogById('smallfox-teacher_34', {
      ...data
    })
  },
  // 监课看板-一键暂停
  pauseLogger(data) {
    sendLogClick('smallfox-teacher_61', {
      ...data
    })
  }
}